import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD2EIEekvHcNNDSSMgoDjugJbjDRVgT43A",
  authDomain: "geneie513.firebaseapp.com",
  projectId: "geneie513",
  storageBucket: "geneie513.firebasestorage.app",
  messagingSenderId: "449519797657",
  appId: "1:449519797657:web:0999cf538826f62227ff08",
  measurementId: "G-0VFB258198"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);

export default app;